export const whyChooseItems = [
  {
    icon: "ri-seedling-line",
    title: "Ingredientes Frescos",
    description: "Selecionamos rigorosamente cada ingrediente para garantir sabor e qualidade em cada produto.",
    color: "accent",
  },
  {
    icon: "ri-store-2-line",
    title: "Produção Própria",
    description: "Fabricamos todos os produtos em nossa própria unidade, com controle total do processo.",
    color: "primary",
  },
  {
    icon: "ri-shield-check-line",
    title: "Segurança Alimentar",
    description: "Seguimos rigorosos padrões de higiene e segurança alimentar em toda a produção.",
    color: "secondary",
  },
  {
    icon: "ri-truck-line",
    title: "Entrega Confiável",
    description: "Rotas programadas e entrega pontual para atacado, varejo e eventos em Fortaleza.",
    color: "accent",
  },
  {
    icon: "ri-building-4-line",
    title: "Atacado & Varejo",
    description: "Atendemos desde o consumidor final até grandes redes de supermercados e revendedores.",
    color: "primary",
  },
  {
    icon: "ri-calendar-event-line",
    title: "Eventos",
    description: "Soluções completas de alimentação para eventos corporativos e particulares de todos os portes.",
    color: "secondary",
  },
  {
    icon: "ri-award-line",
    title: "Qualidade Garantida",
    description: "Mais de 20 anos de experiência e milhares de clientes satisfeitos em Fortaleza.",
    color: "accent",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Excelente Atendimento",
    description: "Equipe dedicada para ajudar você a encontrar a melhor solução para seu negócio ou evento.",
    color: "primary",
  },
];